import { Label } from "@/components/ui/label";
import { Settings, ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import type { FunnelData, ColorScheme } from "../../types";
import { useState } from "react";
import { ColorPicker } from "./ColorPicker";
import { FontSettings } from "./FontSettings";
import { IconSelector } from "./IconSelector";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
interface LogoMakerSettingsProps {
  data: FunnelData;
  onUpdate: (updates: Partial<FunnelData>) => void;
  colors: ColorScheme;
  LOGO_FONTS: Array<{
    value: string;
    label: string;
    className: string;
  }>;
  FONT_SIZES: Array<{
    value: string;
    label: string;
  }>;
  FONT_WEIGHTS: Array<{
    value: string;
    label: string;
  }>;
}
export const LogoMakerSettings = ({
  data,
  onUpdate,
  colors,
  LOGO_FONTS,
  FONT_SIZES,
  FONT_WEIGHTS
}: LogoMakerSettingsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleColorUpdate = (type: 'text' | 'icon', color: string) => {
    if (type === 'text') {
      onUpdate({
        logoConfig: {
          ...data.logoConfig,
          color
        }
      });
    } else {
      onUpdate({
        logoConfig: {
          ...data.logoConfig,
          iconColor: color
        }
      });
    }
  };
  return <div className="space-y-4">
      <Label className="text-base">Logó beállítások</Label>
      <div className="border rounded-lg">
        <div className="p-4 border-b">
          <div className="flex flex-col gap-4">
            <div className="flex gap-3 items-end">
              <div className="flex-[2]">
                <Label htmlFor="brandName" className="mb-2 block">Szöveg</Label>
                <Input id="brandName" value={data.siteName} onChange={e => onUpdate({
                siteName: e.target.value
              })} placeholder="Your Brand Name" className="bg-white" />
              </div>
              <div className="flex gap-2">
                <ColorPicker label="" value={data.logoConfig?.color || colors.primary} onChange={color => handleColorUpdate('text', color)} themeColors={colors} />
              </div>
            </div>
          </div>
        </div>

        <Collapsible open={isOpen} onOpenChange={setIsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full flex items-center justify-between p-4 bg-slate-50">
              <div className="flex items-center gap-2">
                <Settings className="w-4 h-4" />
                <span>Logó beállítások</span>
              </div>
              <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent>
            <div className="p-4 space-y-4 bg-gray-50/50">
              <div className="space-y-2">
                <IconSelector data={data} onUpdate={onUpdate} />
                {data.logoConfig?.icon && <ColorPicker label="Icon Color" value={data.logoConfig?.iconColor || data.logoConfig?.color || colors.primary} onChange={color => handleColorUpdate('icon', color)} themeColors={colors} />}
              </div>
              <FontSettings data={data} onUpdate={onUpdate} LOGO_FONTS={LOGO_FONTS} FONT_SIZES={FONT_SIZES} FONT_WEIGHTS={FONT_WEIGHTS} />
            </div>
          </CollapsibleContent>
        </Collapsible>
      </div>
    </div>;
};